import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./components/layout/Layout";
import { ScrollToTop } from "./components/layout/ScrollToTop";
import Index from "./pages/Index";
import LearnWithUs from "./pages/LearnWithUs";
import Home2 from "./pages/Home2";
import NotFound from "./pages/NotFound";
import Community from "./pages/Community";
import AboutUs from "./pages/AboutUs";
import CommunityGlobeJson from "./components/globe/CommunityGlobeJson";
import CinematicStory from "./components/home/CinematicStory";
import Courses from "./pages/Courses";
import Pricing from "./pages/Pricing";
import Onboarding from "./pages/Onboarding";
import Support from "./pages/Support";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCanceled from "./pages/PaymentCanceled";
import TeamApplication from "./pages/TeamApplication";
import Teams from "./pages/Teams";
import Merchandise from "./pages/Merchandise";
import Events from "./pages/Events";
import DanceLab from "./pages/DanceLab";
import DanceLabEvent from "./pages/DanceLabEvent";
import WaitlistCountdown from "./pages/WaitlistCountdown";
import AdminSync from "./pages/AdminSync";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true,
        }}
      >
        <ScrollToTop />
        <Routes>
          {/* Standalone routes WITHOUT Layout (no nav/footer) */}
        <Route path="/waitlist" element={<WaitlistCountdown />} />
        <Route path="/early-access" element={<WaitlistCountdown />} />
        <Route path="/admin-sync" element={<AdminSync />} />
          
          {/* All other routes WITH Layout */}
          <Route path="/*" element={
            <Layout>
              <Routes>
                <Route path="/" element={<Index />} />
                <Route path="/about" element={<AboutUs />} />
                <Route path="/community" element={<Community />} />
                <Route path="/community-globe" element={<CommunityGlobeJson />} />
                <Route path="/cinematic" element={<CinematicStory />} />
                <Route path="/learn" element={<LearnWithUs />} />
                <Route path="/home2" element={<Home2 />} />
                
                {/* Payment Routes */}
                <Route path="/payment-success" element={<PaymentSuccess />} />
                <Route path="/payment-canceled" element={<PaymentCanceled />} />
                
                {/* Courses Page */}
                <Route path="/courses" element={<Courses />} />
                <Route path="/teams" element={<Teams />} />
                <Route path="/merchandise" element={<Merchandise />} />
                <Route path="/events" element={<Events />} />
                <Route path="/dance-lab" element={<DanceLab />} />
                <Route path="/dance-lab/:citySlug" element={<DanceLabEvent />} />
                <Route path="/pricing" element={<Pricing />} />
                <Route path="/onboarding" element={<Onboarding />} />
                <Route path="/support" element={<Support />} />
                <Route path="/apply" element={<TeamApplication />} />
                
                {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
                <Route path="*" element={<NotFound />} />
              </Routes>
            </Layout>
          } />
        </Routes>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
